import classnames from "classnames";
import React from "react";

// tslint:disable-next-line:no-var-requires
const style = require("./InformationButton.scss");

export interface InformationButtonProps {
    readonly onClick?: () => void;
}

export default function InformationButton({ onClick }: InformationButtonProps) {
    return (
        <button
            className={classnames(style.informationButton)}
            onClick={onClick}
        >
            i
        </button>
    );
}
